import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BehaviourTrackerService {

  selectedDayData: BehaviorSubject<any> = new BehaviorSubject({});

  constructor() {
  }
}
